import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { OAuthViewModel } from "../../features/oauth/oauth-viewmodel";
import { useViewModel } from "../../viewmodel/use-view-model";
export const OAuthLogin = () => {
    const vm = useViewModel(OAuthViewModel);
    const { t } = useTranslation();
    useEffect(() => {
        const redirect = async () => {
            // Replace current state in history, so user cannot use Back button in browser to navigate to this page
            window.history.replaceState(null, "", "/#");
            window.location.href = await vm.generateRedirectUri();
        };
        setTimeout(redirect, 10);
    }, []);
    return (_jsx(_Fragment, { children: _jsx("div", { className: "d-flex justify-content-center align-items-center", children: _jsxs("div", { className: "card mt-5 mt-5 w-50", children: [_jsx("h6", { className: "card-header pt-2 pb-2", children: t("oauth.login") }), _jsx("div", { className: "card-body", children: t("oauth.loggingIn") })] }) }) }));
};
